module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"advisor":"@:labels.advisor"},"fr":{"advisor":"@:labels.advisor"}}')
  delete Component.options._Ctor
}
